import { render, staticRenderFns } from "./SubventionRules.vue?vue&type=template&id=c20f23ec&scoped=true"
import script from "./SubventionRules.vue?vue&type=script&lang=js"
export * from "./SubventionRules.vue?vue&type=script&lang=js"
import style0 from "./SubventionRules.vue?vue&type=style&index=0&id=c20f23ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20f23ec",
  null
  
)

export default component.exports